import React from 'react'
import About from '../../components/about/About';
import CarouselContainer from '../../components/carousel/CarouselContainer';
import Services from '../../components/services/Services';
import Mission from '../../components/misssion/Mission';
import WhatWeExpect from '../Expectation/Expectation';
import OurTeam from '../Teams/Team';
import FAQ from '../Faq/Faq';
import UBLanding from '../../components/UbsoftLanding';
import HeroDecorativeSection from '../../components/HeroDecorativeSection';
import ExploreStudios from '../Studios';
import CEOSection from '../CEOSectio';
import WhyUbiSoft from '../WhyUbiSoft';
import TrustedMarquee from '../TrustedMarquee';

const HomePage = () => {
    return (
        <div>
           
        <UBLanding/>
          <TrustedMarquee/>
        <HeroDecorativeSection/>
      
         
             <CEOSection/>
            <Mission/>
            <OurTeam/>
          <WhyUbiSoft/>
          
           <Services />
           <WhatWeExpect/>
           <FAQ/> 
        </div>
    )
}

export default HomePage;
